import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Pain points" className="border-y border-grape/10 bg-white/70" data-id="element-106" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px',
      paddingTop: "11px"
    }} data-id="element-107" data-mp="26xmrx1867me0">
        <h2 className="text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-108" data-mp="2bvy3bge464yc">
          Does this sound like you?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-109" data-mp="21z36d1xhocm6">
          You love the job, but every time you sit in your cruiser to write a report, you get lost in
          technical jargon, legal loopholes, and the fear of a defense attorney shredding your words.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-grape" data-id="element-110" data-mp="3id35iaoify8d">
          It’s not a lack of skill. It’s a lack of a <span className="text-blush" data-id="element-111" data-mp="3nc5wwsbki5xv">Tactical Framework</span>.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-112" data-mp="1yzvkpmzegxwk">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape/15 bg-cream p-5" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-113" data-mp="1u23seruuf9ru" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-114" data-mp="1b4amrhsu4lqr">
                {p.emoji}
              </span>
              <div data-id="element-115" data-mp="1k2mnwdrbv1xg">
                <h3 className="text-sm font-bold text-plum" data-id="element-116" data-mp="1k2340ri4a3gs">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-117" data-mp="30gcrljejbo6k">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-118" data-mp="2vkxewus9jybq">
          <p className="font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-119" data-mp="1t43n74qn2ixv">
            ✨ If you answered YES, SIGMA SMART™ has the solution.
          </p>
        </div>
      </div>
    </section>;
}